import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateProduct } from "./updateProduct.request";
import { UpdateProductResponseData } from "./updateProduct.types";

const useUpdateProduct = (
  options?: MutationOptions<
    UpdateProductResponseData,
    ApiServiceError<ApiError>
  >
) => {
  return useMutation({
    mutationFn: requestUpdateProduct,
    ...options
  });
};

export default useUpdateProduct;
